import { type FunctionComponent, useCallback } from "react";
import { graphql, useFragment } from "react-relay";
import "swiper/css";
import "swiper/css/navigation";

import type { itemVideoUpNextWidgetItemVideo$key } from "scmp-app/queries/__generated__/itemVideoUpNextWidgetItemVideo.graphql";

import { Container, DurationBadge, Headline, StyledBaseImage, ThumbnailContainer } from "./styles";

export type Props = {
  className?: string;
  onSelect: (id: string) => void;
  reference: itemVideoUpNextWidgetItemVideo$key;
};

export const VideoUpNextWidgetItem: FunctionComponent<Props> = ({
  className,
  onSelect,
  reference,
}) => {
  const data = useFragment(
    graphql`
      fragment itemVideoUpNextWidgetItemVideo on Video {
        entityId
        duration
        headline
        socialHeadline
        image(filter: { type: MAIN_IMAGE }) {
          style(filter: { style: "wide_landscape" }) {
            url
          }
        }
      }
    `,
    reference,
  );

  const title = data.socialHeadline ?? data.headline ?? undefined;

  const handleClick = useCallback(() => {
    onSelect(data.entityId);
  }, [onSelect, data.entityId]);

  return (
    <Container className={className} onClick={handleClick}>
      <ThumbnailContainer>
        <StyledBaseImage
          $aspectRatio="160 / 107"
          $objectFit="cover"
          alt={title}
          disableLinkingData
          src={data.image?.style?.url ?? undefined}
        />
        {data.duration ? <DurationBadge>{data.duration}</DurationBadge> : null}
      </ThumbnailContainer>
      <Headline>{title}</Headline>
    </Container>
  );
};

VideoUpNextWidgetItem.displayName = "VideoUpNextWidgetItem";
